var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{attrs:{"title":_vm.i18n.title}},[_c('div',{staticClass:"order-warp"},[_vm._l((_vm.borrowItems),function(item,i){return _c('order-item',{key:i,attrs:{"item":item}})}),_vm._l((_vm.finishItems),function(item,i){return _c('order-item',{key:i,attrs:{"item":item}})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }